module.exports = [
    { docName: "MessengerParticipation", docTitle: "Sembra Messenger Updated Agreement", docTaxID: true },
    // { docName: "UpdatedCSA", docTitle: "SembraCare Updated Customer Service Agreement", docTaxID: false }
]
